import { CheckCircle } from "@mui/icons-material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { Popover } from "@mui/material";
import React, { useRef } from "react";
import { useDisclosure } from "@hooks";
import Image from "next/image";
import { getOpsUrl } from "@utils/getOpsUrl";
import { useGlobalTeam } from "./base-layout/header/useGlobalTeam";

export const ROSwitcher = () => {
    const ref = useRef<HTMLDivElement>(null);

    const disclosure = useDisclosure();
    const { selectedTeam } = useGlobalTeam();

    const openOps = () => {
        const opsBaseUrl = getOpsUrl();
        const opsUrl = `${opsBaseUrl}?organizationId=${selectedTeam?.organizationId}`;
        window.open(`${opsUrl}`, "_blank");
    };

    return (
        <div className="my-6">
            <div
                onClick={disclosure.onToggle}
                ref={ref}
                className="flex cursor-pointer items-center justify-between"
            >
                <div className="flex items-center gap-2">
                    <Image
                        src={"/images/request-logo.svg"}
                        alt="Logo"
                        className="block h-[22px]"
                        width={22}
                        height={22}
                    />
                    <span className="text-2xl font-semibold">Accounting</span>
                    <UnfoldMoreIcon className="relative top-[2px] text-[20px]" />
                </div>
            </div>

            <Popover
                open={disclosure.isOpen}
                anchorEl={ref.current}
                onClose={disclosure.onClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                classes={{
                    paper: "shadow-lg rounded w-[220px] p-2 -ml-3.5 mt-1",
                }}
                elevation={0}
            >
                <div className="flex w-full flex-col items-center">
                    <div
                        onClick={() => {
                            openOps();
                            disclosure.onClose();
                        }}
                        className="my-1 w-full cursor-pointer rounded bg-gray-100 p-3 pt-2 transition-colors hover:bg-gray-300"
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <span className="text-[16px] font-semibold text-[#050B20]">
                                    Operations
                                </span>
                            </div>
                        </div>
                        <span className="mt-1 text-xxs">
                            Accounts Payable & Receivable
                        </span>
                    </div>

                    <div className="my-1 w-full cursor-not-allowed rounded bg-gray-100 p-3 pt-2 transition-colors">
                        <div className="flex items-center justify-between">
                            <span className="text-[16px] font-semibold text-[#050B20]">
                                Accounting
                            </span>
                            <CheckCircle className="text-[20px] text-black" />
                        </div>
                        <span className="mt-1 text-xxs">
                            Track Financials and Generate Reports
                        </span>
                    </div>
                </div>
            </Popover>
        </div>
    );
};
